var _defs, _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insta_inline_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.17 14.17"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".insta_inline_svg__cls-1{fill:#1d1d1b}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "insta_inline_svg__cls-1",
    d: "M9.56 13H4.61a3.44 3.44 0 01-3.43-3.44V4.61a3.44 3.44 0 013.43-3.43h5A3.44 3.44 0 0113 4.61v5A3.44 3.44 0 019.56 13zM4.61 2.18a2.43 2.43 0 00-2.43 2.43v5A2.43 2.43 0 004.61 12h5A2.43 2.43 0 0012 9.56V4.61a2.43 2.43 0 00-2.44-2.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "insta_inline_svg__cls-1",
    d: "M7.09 10.07a3 3 0 113-3 3 3 0 01-3 3zm0-5.07A2.11 2.11 0 109.2 7.09 2.1 2.1 0 007.09 5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "insta_inline_svg__cls-1",
    cx: 10.03,
    cy: 3.84,
    r: 0.9
  })));
}

export default SvgInstainline;